import * as React from 'react';
import { connect } from 'react-redux';
import { setTheme } from './action-creators';
import { resolveThemeContextSyncIfLoadedOrThrow } from '../resolve-component';
import { State, Dispatch } from '../State';

export type ThemeOnChangeCallback = (newTheme: any, newThemeName: string) => any;

export type ThemeContext = {
  context: any;
  name: string;
  onChange: (callback: ThemeOnChangeCallback) => any;
  set: (themeName: string) => Promise<any>;
};

export type WithThemeProps<TTheme> = {
  theme: TTheme;
  themeName: string;
  setTheme: (themeName: string) => Promise<any>;
};

export function withTheme<TProps, TTheme>(Component: React.ComponentType<TProps & WithThemeProps<TTheme>>) {
  return (connect(
    (state: State) => ({
      currentTheme: state.currentTheme,
    }),
    (dispatch: Dispatch) => ({
      setTheme(themeName: string) {
        return dispatch(setTheme(themeName));
      },
    }),
  )((props: { currentTheme: string; setTheme: (themeName: string) => any }) => {
    const themeProps: WithThemeProps<TTheme> = {
      theme: props.currentTheme ? resolveThemeContextSyncIfLoadedOrThrow(props.currentTheme) : null,
      themeName: props.currentTheme,
      setTheme: (newThemeName: string) => props.setTheme(newThemeName),
    };
    const { currentTheme, ...restProps } = props;
    return <Component {...restProps as any} {...themeProps} />;
  }) as any) as React.StatelessComponent<TProps>;
}

export function coalesceName(themeName: string, previousTheme = '') {
  if (themeName === 'default') {
    return '';
  }
  if (typeof themeName === 'string') {
    return themeName;
  }
  return previousTheme === 'default' ? '' : previousTheme;
}
